import { Component } from 'react';
import { connect } from "react-redux";
import { WorldMapProvider } from "../../contexts/WorldMapContext";
import { getSearchFromUrl } from "../../util/library/Router";
import { SOCKET_FUNC, SOCKET_NAME } from '../../web-socket/constants';
import WSService from "../../web-socket/web-socket-service";
import Guide from "./_component/Guide";
import Map from "./_component/Map";
import Content from "./Content";
import { routeActions } from "./reducer";
import "./style.scss";

interface IProps {
    initialData(payload: any): void

    getLocations(): void

    showAutoRoute(payload: any): void

    reset(): void
}

class RoutePage extends Component<IProps> {

    constructor(props: IProps) {
        super(props);
        this.props.reset();
        let source_id = null, destination_id = null;
        const params = getSearchFromUrl();
        if (params.length >= 2) {
            params.forEach(item => {
                const [label, value] = item.split('=');
                if (label === 'source')
                    source_id = value
                else if (label === 'destination')
                    destination_id = value
            })
        }

        if (source_id && destination_id)
            this.props.initialData({ source_id, destination_id });


        this.props.getLocations();
    }

    componentDidMount() {
        new WSService({
            groups: ['auto-route'],
            listener: {
                lev: SOCKET_NAME.PAGE,
                func: (value: any) => {
                    switch (value.function) {
                        case SOCKET_FUNC.AUTO_ROUTE: {
                            this.props.showAutoRoute(value);
                            break;
                        }
                        default:
                            return;
                    }
                }
            }
        });
    }

    componentWillUnmount() {
        WSService.close(SOCKET_NAME.PAGE, ['auto-route']);
    }

    render() {
        return <div className="m-header relative bgPage">
            <WorldMapProvider>
                <Map />
                <Content />
                <Guide />
            </WorldMapProvider>
        </div>;
    }
}

export default connect(() => ({}), {
    initialData: routeActions.initialDataRequest,
    getLocations: routeActions.getLocationsRequest,
    showAutoRoute: routeActions.autoRouteSuccess,
    reset: routeActions.reset,
})(RoutePage);

